// Souscription Web Push VAPID côté navigateur (universel — restaurateurs, chauffeurs, passagers).
// Le SW gère l'affichage des notifs même quand la tablette/téléphone est en veille profonde.
import api from "./api";

function urlB64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const clean = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(clean);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}


async function _getReg() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    throw new Error("Ce navigateur ne supporte pas les notifications push (utilisez Chrome/Edge sur Android ou desktop).");
  }
  return await navigator.serviceWorker.ready;
}


export async function getPushStatus() {
  try {
    if (!("Notification" in window) || !("serviceWorker" in navigator) || !("PushManager" in window)) {
      return { enabled: false, permission: "unsupported" };
    }
    const reg = await navigator.serviceWorker.getRegistration();
    const sub = reg ? await reg.pushManager.getSubscription() : null;
    return { enabled: !!sub, permission: Notification.permission };
  } catch {
    return { enabled: false, permission: "default" };
  }
}


// Base : /api/push (générique) — les endpoints restaurateur historiques restent supportés.
export async function subscribeWebPush(base = "/push") {
  const perm = Notification.permission === "granted"
    ? "granted"
    : await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Autorisation refusée.");

  const reg = await _getReg();
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get(`${base}/vapid-public`);
    if (!data?.public_key) throw new Error("Clé VAPID indisponible côté serveur.");
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.public_key),
    });
  }
  const payload = sub.toJSON();
  await api.post(`${base}/subscribe`, { endpoint: payload.endpoint, keys: payload.keys });
  return sub;
}


export async function unsubscribeWebPush(base = "/push") {
  const reg = await _getReg();
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try {
    await api.post(`${base}/unsubscribe`, { endpoint: sub.endpoint, keys: sub.toJSON().keys });
  } catch {}
  await sub.unsubscribe();
}


export async function testWebPush(base = "/push") {
  const { data } = await api.post(`${base}/test`);
  return data;
}
